<template>
  <div>
    <el-form-item :label="data.label" style="width:90%">
      <el-col :span="8">
        <el-select
          :disabled="disabled"
          :class="verifyFields(data, validation) && !disabled ? 'input-warning':''"
          style="margin-left:11%"
          :placeholder="data.placeholder"
          v-model="data.model"
          :required="data.required"
          @input="saveDataToLocalStorage(data.model, data.name)"
        >
          <el-option
            v-for="(option, index) in data.optionValue"
            :key="index"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-col>
      <el-col :span="23">
        <el-alert
          v-if="verifyFields(data, validation) && !disabled"
          :title="`Falta completar: ${data.label}`"
          type="error"
          class="message-warning"
          :closable="false"
        />
      </el-col>
    </el-form-item>
  </div>
</template>

<script>
import { verifyFields, persistToNewProviderStorage, saveDataToLocalStorage } from '../helpers/utils.js'

export default {
  data () {
    return {
      paramsCountry: this.$route.params.country,
      cond: true
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    locations: {
      type: [Object, Array]
    },
    banks: {
      type: [Object, Array]
    },
    bankAccountTypes: {
      type: [Object, Array]
    }
  },
  watch: {
    'data.model': {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          this.updateSelectOptions()
        }
      }
    }
  },
  methods: {
    verifyFields,
    persistToNewProviderStorage,
    saveDataToLocalStorage,
    updateSelectOptions () {
      // console.log('alta usuario')
      // EN CASO DE EXISTIR PARAMSCOUNTRY, ES DECIR NO ES EL ALTA DE USUARIO, MAPEO LAS OPCIONES PARA DARLE UN LABEL Y UN VALUE PARA QUE PUEDAN SER PROCESADAS
      // POR EL SELECT
      // SET ID A LAS PROVINCIAS
      if (this.$props.data.name === 'location') {
        this.data.optionValue = this.$props.data.optionValue.map((opt) => {
          if (typeof opt === 'string') {
            // console.log('location', this.$props.data)
            return {
              label: opt,
              value: this.$props.locations.data.find((loc) => loc.codRegion === opt).idProvince
            }
          } else {
            return opt
          }
        })
      }
      // SET ID A LOS BANCOS
      if (this.$props.data.name === 'bank' || this.$props.data.name === 'bank2') {
        if (this.$props.data.model !== '') {
          // console.log('data bancos', this.$props.banks)
          this.data.optionValue = this.$props.data.optionValue.map((opt) => {
            if (typeof opt === 'string') {
              // console.log('find', this.$props.banks.data.find((bank) => bank.bank === opt).idBank)
              return {
                label: opt,
                value: this.$props.banks.data.find((bank) => bank.bank === opt).idBank
              }
            } else {
              return opt
            }
          })
        }
      }
      // SET ID A LOS TIPOS DE CUENTA
      if (this.$props.data.name === 'accountType' || this.$props.data.name === 'accountType2') {
        this.data.optionValue = this.$props.data.optionValue.map((opt) => {
          if (typeof opt === 'string') {
            return {
              label: opt,
              value: this.$props.bankAccountTypes.find((bankAccountType) => bankAccountType.codeERP === opt).idBankAccountType
            }
          } else {
            return opt
          }
        })
        // if (this.$props.data.model !== '') {
        // }
      }
      // SET ID AL RESTO DE CAMPOS QUE TIENEN INDICES ORDENADOS DESDE EL 1
      this.$props.data.optionValue = this.$props.data.optionValue.map((opt, index) => {
        if (typeof opt === 'string') {
          return {
            label: opt,
            value: index + 1
          }
        } else {
          return opt
        }
      })
      // SETEO EL MODEL CON EL VALUE CORRESPONDIENTE
      let optionModel
      if ((this.$props.data.name === 'bank' || this.$props.data.name === 'bank2') && !this.paramsCountry) {
        // ESTA CONDICION ES PQ EN ALTA USUARIO EL MODEL ES STRING, NO NUMBER
        optionModel = this.$props.data.optionValue.find(opt => opt.value === this.$props.data.model)
      } else {
        optionModel = this.$props.data.optionValue.find(opt => opt.value === Number(this.$props.data.model))
      }
      if (optionModel) {
        this.data.model = optionModel.value
      }
      // console.log('props.data', this.$props.data)
      // console.log('props.data.model', this.$props.data.model)
      // console.log('optionModel', optionModel)
    }
  },
  mounted () {
    if (this.data.model || !this.paramsCountry) {
      this.updateSelectOptions()
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectInput.vue?76fe7560